<template>
  <div class="frame19_body">
    <div class="frame19">
      <div class="frame19_top">
        盈利预测
        <img
          src="../../../../public/img/shares_Info/close.png"
          alt=""
          @click="frame19_close"
        />
      </div>
      <div class="frame19_content">
        <div class="frame19_content_title">预测PE（市盈率）</div>
        <div class="frame19_content_text">
          【释义】：每股市价为未来某年预测每股收益的倍数。预测每股收益取自指定日期市场一致预测。
        </div>
        <div class="frame19_content_text">【算法】：市盈率=股票指定交易日期的收盘价/预测每股收益（综合值）  </div>
        <div class="frame19_content_text">【单位】：倍</div>
      </div>
      <div class="frame19_content">
        <div class="frame19_content_title">预测净利润增长率（同比增长）</div>
        <div class="frame19_content_text">
          【释义】：预测净利润增长率是指预测年度（Y）的预测净利润（无论是否已有公布值）相对于上一年度(Y-1)的净利润(年报已公布就用公布值，年报没有公布就用预测值)的增长比例，预测净利润增长率越高，代表对企业发展前景越有信心。 
        </div>
        <div class="frame19_content_text">【算法】：预测净利润增长率=[预测净利润（Y）-净利润（Y-1）]/ABS净利润(y-1)*100 注：净利润为归属母公司股东净利润</div>
        <div class="frame19_content_text">【单位】：%</div>
      </div>
      <div class="frame19_content">
        <div class="frame19_content_title">市盈率相对增长比率（PEG）</div>
        <div class="frame19_content_text">
          【释义】：PEG值，常用估值指标之一，综合考虑了目标企业的市盈率水平和未来盈利成长性。通常，PEG的算法是公司市盈率(PE)除以公司未来3到5年的每股收益复合增长率。PEG估值法克服了传统市盈率估值的局限性，对于高PE的公司如果未来成长性也很高，那么高PE也可以接受。因此，通常认为PEG估值偏高，反映市场对这只股票的估值可能高于其未来业绩成长性；如果PEG值偏低，则反之。一般认为PEG值接近1是合理估值。
        </div>
        <div class="frame19_content_text">【算法】：预测PEG=预测PE/企业年盈利增长率（G值） </div>
        <div class="frame19_content_text">【单位】：-</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    frame19_close() {
      this.$emit("frame19_close");
    },
  },
};
</script>

<style scoped>
.frame19_body {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  z-index: 9999999;
}
.frame19 {
  width: 448px;
  height: 920px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 36px;
  margin: 50px auto;
  margin-top: 200px;
}
.frame19_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame19_content {
  margin-top: 28px;
}
.frame19_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame19_content_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.frame19_content_text {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
</style>